import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SearchSystemState } from './search-system.model';
import { featureKey } from './search-system.reducers';

const selectFeature = createFeatureSelector<SearchSystemState>(featureKey);

export const selectPage = createSelector(selectFeature, (state: SearchSystemState) => state.latestPage);
